import { Grid, Stack, Skeleton, Box } from '@mui/material'
import React from 'react'

function EditEventsSkeleton() {
  return (
    <Stack
      component="div"
      padding={2}
      flexDirection="column"
      height="100%"
      width="50%"
      margin="1.5rem auto"
      data-testid="edit-events-skeleton"
    >
      <Grid container height={60} mb={3} mt={10}>
        <Skeleton height="100%" width="40%" />
      </Grid>
      <Box display="flex" flexDirection="column" padding={2} bgcolor="#EEE" borderRadius={2}>
        <Grid container height={20}>
          <Skeleton height="100%" width="100%" />
        </Grid>
        <Grid container height={20}>
          <Skeleton height="100%" width="100%" />
        </Grid>
        <Grid container height={20}>
          <Skeleton height="100%" width="90%" />
        </Grid>
        <Grid container height={20} mb={2}>
          <Skeleton height="100%" width="80%" />
        </Grid>
      </Box>
      <Grid container height={120} mb={2}>
        <Skeleton height="100%" width="100%" />
      </Grid>
      <Grid container height={120} mb={2}>
        <Skeleton height="100%" width="100%" />
      </Grid>
      <Box display="flex" flex={1} flexDirection="row" alignItems="center" justifyContent="right" gap="2rem">
        <Skeleton height="4.5rem" width="15%" />
        <Skeleton height="4.5rem" width="15%" />
      </Box>
    </Stack>
  )
}

export default EditEventsSkeleton
